import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().trim().email("Ongeldig e-mailadres").max(255, "E-mail te lang"),
  password: z.string().min(1, "Wachtwoord is verplicht"),
});

export const signupSchema = z.object({
  email: z.string().trim().email("Ongeldig e-mailadres").max(255, "E-mail te lang"),
  password: z.string()
    .min(8, "Wachtwoord moet minimaal 8 tekens zijn")
    .max(72, "Wachtwoord mag maximaal 72 tekens zijn")
    .regex(/[a-z]/, "Wachtwoord moet minimaal 1 kleine letter bevatten")
    .regex(/[A-Z]/, "Wachtwoord moet minimaal 1 hoofdletter bevatten")
    .regex(/[0-9]/, "Wachtwoord moet minimaal 1 cijfer bevatten"),
  confirmPassword: z.string(),
  firstName: z.string().trim().min(1, "Voornaam is verplicht").max(100, "Voornaam te lang"),
  lastName: z.string().trim().min(1, "Achternaam is verplicht").max(100, "Achternaam te lang"),
  gender: z.enum(["M", "V", "O"], { errorMap: () => ({ message: "Selecteer een geslacht" }) }),
  skillLevel: z.string().refine(val => {
    const num = parseInt(val);
    return num >= 1 && num <= 9;
  }, "Speelsterkte moet tussen 1 en 9 zijn"),
  birthDate: z.string().min(1, "Geboortedatum is verplicht"),
  clubId: z.string().min(1, "Selecteer je club"),
  sports: z.array(z.enum(["tennis", "padel"])).min(1, "Selecteer minimaal 1 sport"),
  confirmMember: z.boolean().optional(),
}).refine(data => data.password === data.confirmPassword, {
  message: "Wachtwoorden komen niet overeen",
  path: ["confirmPassword"],
});

export const profileUpdateSchema = z.object({
  firstName: z.string().trim().min(1, "Voornaam is verplicht").max(100, "Voornaam te lang"),
  lastName: z.string().trim().min(1, "Achternaam is verplicht").max(100, "Achternaam te lang"),
  gender: z.enum(["M", "V", "O"], { errorMap: () => ({ message: "Selecteer een geslacht" }) }),
  skillLevel: z.string().refine(val => {
    const num = parseInt(val);
    return num >= 1 && num <= 9;
  }, "Speelsterkte moet tussen 1 en 9 zijn"),
  birthDate: z.string().min(1, "Geboortedatum is verplicht"),
  hideAge: z.boolean().optional(),
});

export const passwordChangeSchema = z.object({
  newPassword: z.string()
    .min(8, "Wachtwoord moet minimaal 8 tekens zijn")
    .max(72, "Wachtwoord mag maximaal 72 tekens zijn"),
  confirmPassword: z.string(),
}).refine(data => data.newPassword === data.confirmPassword, {
  message: "Wachtwoorden komen niet overeen",
  path: ["confirmPassword"],
});

export const emailChangeSchema = z.object({
  email: z.string().trim().email("Ongeldig e-mailadres").max(255, "E-mail te lang"),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type SignupInput = z.infer<typeof signupSchema>;
export type ProfileUpdateInput = z.infer<typeof profileUpdateSchema>;
export type PasswordChangeInput = z.infer<typeof passwordChangeSchema>;
export type EmailChangeInput = z.infer<typeof emailChangeSchema>;
